import { baseFetch } from "./baseFetch";
import { BILLING_CYCLE_DAY_URL } from "./urls";

export const fetchBillingCycleDay = async (token: string) =>
  baseFetch(BILLING_CYCLE_DAY_URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
